import React from 'react';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import { acceptedAttestation } from 'legacy/src/components/learnosity/utils/helpers';
import ResourceAssign from 'chameleon-src/components/assign/ResourceAssign';
import { QB_APP_ID } from 'chameleon-src/constants/subjects';

const AssignAction = ({
  userData,
  subjectInfo,
  assessment = {},
  onAssign,
  isReassign,
  title,
  onClose,
  userSubjects,
  subjectData,
  forcePopupClose,
  isVideo = false,
  videoResource = {},
  role,
  onVideoAssigned = () => {},
  userClasses,
  sendTelemetryEvent = () => {},
  resources,
  disabled,
}) => {
  const { me, isAdmin, isCoordinator } = userData;
  const { id: masterSubjectId } = subjectData;
  const userSubject = userSubjects.find(
    (us) => us.masterSubjectId === masterSubjectId && us.parentId === QB_APP_ID,
  );
  const acceptedPracticeExamToc =
    userSubject && acceptedAttestation(me, userSubject.initId);
  const isPreApSubject = subjectInfo && subjectInfo.isPreApSubject;
  const isScrambleable =
    assessment &&
    (assessment.canScrambleQuestions || !assessment.isPracticeExam);
  const isAdminOrCoordinator = isAdmin || isCoordinator;
  const isSPP = assessment.is_spp;
  const isPPC = assessment.is_ppc || assessment.type === 'ppc';

  return isVideo ? (
    <ResourceAssign
      videoResource={videoResource}
      items={resources}
      subject={subjectInfo}
      isReassign={isReassign}
      onSubmit={onVideoAssigned}
      isAdminOrCoordinator={isAdminOrCoordinator}
      userClasses={userClasses}
      disabled={disabled}
    />
  ) : (
    <AssignItem
      assessment={assessment}
      role={role}
      onAssignRedirect={false}
      forcePopupClose={forcePopupClose}
      isAdminOrCoordinator={isAdminOrCoordinator}
      scrambleable={isScrambleable}
      me={me}
      subjectInfo={subjectInfo}
      itemId={assessment.id || assessment.assessment_id}
      itemTitle={assessment.title}
      isSampleQuiz={assessment.isSampleQuiz}
      isFinalExam={assessment.isFinalExam}
      isPilot={assessment.isPilot}
      learnosityReference={assessment.learnosity_reference}
      isSPP={isSPP}
      isLC={assessment.is_learning_checkpoint}
      hideSecureToggle={assessment.isSecure}
      acceptedPracticeExamToc={acceptedPracticeExamToc}
      onAssign={onAssign}
      sendTelemetryEvent={sendTelemetryEvent}
      onClose={() => onClose()}
      ariaLabel={`${isReassign ? 'Reassign' : 'Assign'} ${
        isPreApSubject || isSPP ? '' : 'Quiz'
      }`}
      button={
        <SingleAction iconName="assign" disabled={disabled}>
          <span className="item-text">
            {title ||
              `${isReassign ? 'Reassign' : 'Assign'} ${
                isPreApSubject || isSPP ? '' : 'Quiz'
              }`}
          </span>
        </SingleAction>
      }
      isPPC={isPPC}
    />
  );
};

AssignAction.propTypes = {
  subjectInfo: PropTypes.object.isRequired,
  assessment: PropTypes.object.isRequired,
  onAssign: PropTypes.func,
  onClose: PropTypes.func,
  tagName: PropTypes.string,
  forcePopupClose: PropTypes.bool,
  role: PropTypes.string,
};

AssignAction.defaultProps = {
  onAssign: () => {},
  onClose: () => {},
  tagName: 'li',
  forcePopupClose: false,
  role: 'button',
};

const mapStateToProps = (state) => {
  const { userData, subject, userSubjects } = state;

  return {
    userData,
    subjectData: subject.data,
    userSubjects,
  };
};

export default connect(mapStateToProps)(AssignAction);
